import { render, staticRenderFns } from "./InsertOfferForm.placements.vue?vue&type=template&id=3bbd3f69&scoped=true&lang=html&"
import script from "./InsertOfferForm.placements.vue?vue&type=script&lang=js&"
export * from "./InsertOfferForm.placements.vue?vue&type=script&lang=js&"
import style0 from "./InsertOfferForm.placements.vue?vue&type=style&index=0&id=3bbd3f69&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bbd3f69",
  null
  
)

export default component.exports